import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLoadingStore = defineStore('loading', () => {
    const isLoading = ref<boolean>(false)
    const isClassFinished = ref<boolean>(false)
    
    return { isLoading, isClassFinished }
})